import transform from '../../../utils/ResponseTransformator'
import mapResponseToObject from '../mappers/mapResponseToObject'
import { IData } from './response'

export default async function(response: Response) {
  let text: string = await response.text()
  text = transform(text)
  const json: IData = JSON.parse(text)
  const rooms = json.items.map(mapResponseToObject)

  return rooms.shift()
}
